import axios from "axios";
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getUrlForUsers } from "../utils/confighelpers";
import { useDispatch, useSelector } from "react-redux";
import { loadingState, setGlobalLoading } from "../redux/reducers/loadingReducer";

const LOCAL_STORAGE_KEY = "app:tenant";
export const DEFAULT_TENANT = "";
// const DEFAULT_TENANT = "codacpoint";

const TenantContext = createContext();

function getTenantFromSubdomain() {
     if (typeof window === "undefined") return DEFAULT_TENANT;

     const host = window.location.hostname; // e.g. fitclub.example.com
     const parts = host.split(".");

     // first part is subdomain
     const subdomain = parts[0].toLowerCase();

     // return TENANTS[subdomain] ? subdomain : DEFAULT_TENANT;
     return subdomain && subdomain !== "localhost" ? subdomain : DEFAULT_TENANT;
     // return subdomain && subdomain !== "localhost" ? subdomain : "codacpoint";
     // return subdomain && subdomain !== "localhost" ? subdomain : "krachtig-en-gezond";
}


const getHostHomePage = async (tenant) => {
     // console.log("tenant", tenant);
     const config = {
          method: "get",
          url: `${getUrlForUsers()}getHostHomePage?Tenant=&businessName=${tenant}`,
     };
     const request = await axios(config);
     // An old club link (the platform changed it, e.g. after a rebrand): go to the same page on the new address,
     // so old links, QR codes and emails keep working. The server sends { message: { movedTo } }.
     const movedTo = request?.data?.message?.movedTo;
     if (request.data.statusCode !== 200 && movedTo && /^[a-z0-9-]+$/.test(movedTo) && movedTo !== tenant) {
          const { protocol, hostname, port, pathname, search, hash } = window.location;
          const rest = hostname.split(".").slice(1).join(".");
          window.location.replace(`${protocol}//${movedTo}.${rest}${port ? `:${port}` : ""}${pathname}${search}${hash}`);
          return { errror: true, moving: true };
     }
     if (request.data.statusCode === 200) {
          // console.log("data", request.data.data);
          const userData = request.data.data;
          return userData

     } else {
          return {
               errror: true
          }
     }
}

export function TenantProvider({ children }) {
     const tenant = useMemo(() => getTenantFromSubdomain(), []);
     const dispatch = useDispatch();
     const loadingReduxState = useSelector(loadingState);
     const [tenantData, setTenantData] = useState({
          businessStatus: "DEFAULT",
          businessId: "",
          businessName: "",
          logo: "",
          business_details: "",
     });
     const [tenantLoading, setTenantLoading] = useState(true);

     useEffect(() => {
          async function fetchTenantData() {
               let moving = false;
               try {
                    setTenantLoading(true);

                    dispatch(setGlobalLoading(true));
                    const tenantDetail = await getHostHomePage(tenant)
                    if (tenantDetail.moving) {
                         moving = true; // keep the loader on while the browser goes to the new address
                         return;
                    }
                    dispatch(setGlobalLoading(false));
                    if (tenantDetail.errror && tenantDetail.errror == true) {

                         setTenantData({
                              businessStatus: "NOTFOUND",
                              businessName: "",
                              logo: "",
                         });
                    } else {

                         setTenantData({
                              businessStatus: "FOUND",
                              businessId: tenantDetail._id,
                              businessName: tenantDetail.business_detail.businessName,
                              logo: tenantDetail.business_detail.logo,
                              business_details: tenantDetail,
                         });

                         try {

                              document.title = tenantDetail.business_detail.businessName;
                              const favicon = document.getElementById("favicon");
                              if (favicon) {
                                   favicon.href = tenantDetail.business_detail.logo;
                              }
                              const appleFavicon = document.getElementById("apple-favicon");
                              if(appleFavicon){
                                   favicon.href = tenantDetail.business_detail.logo;
                              }
                         } catch (error) {

                         }
                    }
               } catch (err) {
                    console.error("Error fetching tenant data:", err);
                    // fallback if API fails
                    setTenantData({
                         businessName: "FitClub",
                         logo: "/default-logo.png",
                    });
               } finally {
                    if (!moving) setTenantLoading(false);
               }
          }

          fetchTenantData();
     }, [tenant]);

     const value = {
          tenant,
          tenantData,
          tenantLoading,
     };

     return (
          <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
     );
}

export function useTenant() {
     const ctx = useContext(TenantContext);
     if (!ctx) {
          throw new Error("useTenant must be used inside a TenantProvider");
     }
     return ctx;
}
